import React, { Component } from 'react';
import connect from "react-redux/es/connect/connect";
import SeoHeaders from "../components/seoheaders";
import * as wActs from "../actions/website-actions";
import {Link} from "react-router-dom";
import Select from "react-select";
import { fetch, addTask } from "domain-task";
import * as wConst from "../consts/website-consts";

class SignUp extends Component {

  constructor(props) {
    super(props);
    this.state = {
      countries: [
        {value: "NL", label: "Netherlands"},
        {value: "TK", label: "Turkey"},
      ],
      genders: [
      ],
      mTypes: [
        {value: "AGENT",label: "Agency/Club/Studio"},
        {value: "MODEL",label: "Independent sex worker"},
      ],
      showSuccess: false
    }
  }

  componentDidMount() {
    this.getGenders();
    this.getCountries();
    this.getTypes();
  }

  getGenders() {
    let lang = this.props.WebPage.Settings.SelectedLocal.toUpperCase(); if(lang == "/") {lang="EN"}
    let headers = {
      'X-Alt-Referer': typeof window == "undefined" ? window.location.href : this.props.WebPage.ServerParams.Referer,
      'X-Alt-Language': lang
    };
    let self = this;
    let act = fetch(`${wConst.ROOT_URL()}/list/gender`, { headers: headers })
      .then(resp => resp.json())
      .then(function (data) {
        if(data.Code == 200) {
          let lst = data.Result.map((v) => {
            return {value: v.Value, label: v.DisplayValue};
          });
          self.setState({genders: lst});
        }
      }).catch(function(ex) {
        console.log(ex);
      });
      addTask(act);
  }

  getTypes() {
    let lang = this.props.WebPage.Settings.SelectedLocal.toUpperCase(); if(lang == "/") {lang="EN"}
    let headers = {
      'X-Alt-Referer': typeof window == "undefined" ? window.location.href : this.props.WebPage.ServerParams.Referer,
      'X-Alt-Language': lang
    };
    let self = this;
    let act = fetch(`${wConst.ROOT_URL()}/list/usertype`, { headers: headers })
      .then(resp => resp.json())
      .then(function (data) {
        if(data.Code == 200) {
          let lst =[];
          let lstM = data.Result.map((v) => {
            if(v.Value !== "Member") {
              lst.push({value: v.Value, label: v.DisplayValue});
            }
          });
          self.setState({mTypes: lst});
        }
      }).catch(function(ex) {
        console.log(ex);
      });
    addTask(act);
  }

  getCountries() {
    let lang = this.props.WebPage.Settings.SelectedLocal.toUpperCase(); if(lang == "/") {lang="EN"}
    let headers = {
      'X-Alt-Referer': typeof window == "undefined" ? window.location.href : this.props.WebPage.ServerParams.Referer,
      'X-Alt-Language': lang
    };
    let self = this;
    let act = fetch(`${wConst.ROOT_URL()}/list/country`, { headers: headers })
      .then(resp => resp.json())
      .then(function (data) {
        if(data.Code == 200) {
          let lst = data.Result.map((v) => {
            return {value: v.Value, label: v.DisplayValue, rec: v};
          });
          self.setState({countries: lst});
        }
      }).catch(function(ex) {
        console.log(ex);
      });
    addTask(act);
  }



  getTerms() {
    return wActs.getCultPath(this.props.WebPage, "/terms");
  }
  getPrivacy() {
    return wActs.getCultPath(this.props.WebPage, "/privacy");
  }

  requestAccess() {
    let rec = {
      "Name": this.Name.value,
      "EmailAddress": this.Email.value,
      "MemberType": this.UserType.state.value ? this.UserType.state.value.value : "",
      "Gender": this.Gender.state.value ? this.Gender.state.value.value : "",
      "PhoneNumber": this.Phone.value,
      "WebPage": this.Webpage.value,
      "Location": this.Location.state.value ? this.Location.state.value.label : "",
      "CountryCode": this.Location.state.value ? this.Location.state.value.value : "",
    };
    if(typeof window !== "undefined" && window.localStorage) {
      window.localStorage.setItem("SIGNUP_EMAIL", this.Email.value);
    }
    console.log("POSTING THIS DATA:", rec);
    this.props.dispatch(wActs.requestAccess(rec,()=> {
      this.Name.value = ""; this.Phone.value = "";
      this.Email.value = ""; this.Webpage.value = "";
      this.UserType.setState({value: undefined});
      this.Gender.setState({value: undefined});
      this.Location.setState({value: undefined});
    }));

  }
  handleSubmit(evt) {
    const data = {
      "UserName": this.formUsername.value,
      "Password": this.formPassword.value,
      "EmailAddress": this.formEmail.value,
      "Type": this.formUserType.state.value ? this.formUserType.state.value.value : "",
      "Source": "escortnews"
    };
    console.log("POSTING THIS DATA:",data);
    this.props.dispatch(wActs.Signup(data,this.props.history, wActs.getCultPath(this.props.WebPage,"/confirm")));
  }


  render() {
    let isReal = wActs.getParameterByName("ticketid", typeof window == "undefined" ? this.props.WebPage.ServerParams.Referer : window.location.href);
    let sText = wActs.getTranslation(this.props.WebPage.Translations,"dash.list.select");
    let eml = typeof window !== "undefined" && window.localStorage ? window.localStorage.getItem("SIGNUP_EMAIL") : "";
    if(wActs.isNullOrEmpty(eml)) { eml=""; }
    let showSuccess = this.state.showSuccess;

    return (
      <div className={`main`}>

        <div className="inner">
          <div className="container">

            <div className="title">
              <div className="h2">
                {wActs.getTranslation(this.props.WebPage.Translations,"page.header.signup")}
              </div>
            </div>

            <div className="inner-block inner-block--not-padding flex flex--between">
              <div className="content">
                {!showSuccess &&
                  <div className="descr-block" style={{marginBottom: "20px"}}>
                    {wActs.getTranslation(this.props.WebPage.Translations, "page.smuglist.signup.text1").replace("{{SeoName}}", this.props.WebPage.Settings.SeoName)}
                  </div>
                }
                {(!isReal && !showSuccess ) &&
                <React.Fragment>
                  <div className="form-row flex flex--between">
                    <div className="input-wrapper">
                      <span className="input-title">{wActs.getTranslation(this.props.WebPage.Translations,"dash.name")}</span>
                      <input ref={(r)=>{ this.Name = r }} type="text" className="input" required=""/>
                    </div>

                    <div className="input-wrapper">
                      <span className="input-title">{wActs.getTranslation(this.props.WebPage.Translations,"page.email")}</span>
                      <input ref={(r)=>{ this.Email = r }} type="text" defaultValue={eml} className="input" required=""/>
                    </div>

                  </div>
                  <div className="form-row flex flex--between">
                    <div className="input-wrapper">
                      <span className="input-title">{wActs.getTranslation(this.props.WebPage.Translations,"page.signup.membershiptype")}</span>
                      <Select placeholder={sText} ref={(r)=>{ this.UserType = r }} style={wActs.customStyles} options={this.state.mTypes}/>
                    </div>

                    <div className="input-wrapper">
                      <span className="input-title">{wActs.getTranslation(this.props.WebPage.Translations,"page.profile.gender")}</span>
                      <Select placeholder={sText} ref={(r)=>{ this.Gender = r }} style={wActs.customStyles} options={this.state.genders}/>
                    </div>

                  </div>
                  <div className="form-row flex flex--between">
                    <div className="input-wrapper">
                      <span className="input-title">{wActs.getTranslation(this.props.WebPage.Translations,"page.profile.phone")}</span>
                      <input ref={(r)=>{ this.Phone = r }} type="text" className="input" required=""/>
                    </div>

                    <div className="input-wrapper">
                      <span className="input-title">{wActs.getTranslation(this.props.WebPage.Translations,"page.profile.location")}</span>
                      <Select placeholder={sText} ref={(r)=>{ this.Location = r }} style={wActs.customStyles} options={this.state.countries}/>
                    </div>

                  </div>
                  <div className="form-row flex flex--between">
                    <div className="input-wrapper">
                      <span className="input-title">{wActs.getTranslation(this.props.WebPage.Translations,"dash.profile.webpage")}</span>
                      <input ref={(r)=>{ this.Webpage = r }} type="text" className="input" required=""/>
                    </div>

                  </div>
                  <div className="agree">
                    <input type="checkbox" id="agree"/>
                    {typeof window !== "undefined" &&
                    <label htmlFor="agree" dangerouslySetInnerHTML={{__html: wActs.getTranslation(this.props.WebPage.Translations,"page.singup.iagreetotheterms")
                        .replace("{{TermsUrl}}",this.getTerms())
                        .replace("{{PrivacyUrl}}",this.getPrivacy())

                    }}></label>
                    }
                  </div>
                  <input type="submit" onClick={() => {this.requestAccess()}} className="btn btn--blue" value={wActs.getTranslation(this.props.WebPage.Translations,"page.submit")}/>
                </React.Fragment>
                }

                {isReal &&
                  <React.Fragment>
                    <form>

                    <div className="input-wrapper">
                      <span className="input-title">{wActs.getTranslation(this.props.WebPage.Translations,"page.signup.membershiptype")}</span>
                      <Select placeholder={sText} ref={(r)=>{ this.formUserType = r }} style={wActs.customStyles} options={this.state.mTypes}/>
                    </div>

                    <div className="input-wrapper">
                      <span className="input-title">{wActs.getTranslation(this.props.WebPage.Translations,"page.login.username")}</span>
                      <div className="input-container">
                        <input ref={(r) => {this.formUsername = r}} type="text" className="input"/>
                        <span className="ico">
                          <i className="fa fa-user"></i>
                        </span>
                      </div>
                    </div>


                    <div className="input-wrapper">
                      <span className="input-title">{wActs.getTranslation(this.props.WebPage.Translations,"page.login.password")}</span>
                      <div className="input-container">
                        <input ref={(r) => {this.formPassword = r}} type="password" className="input"/>
                        <span className="ico">
                          <i className="fa fa-lock"></i>
                        </span>
                      </div>
                    </div>

                      <div className="input-wrapper">
                        <span className="input-title">{wActs.getTranslation(this.props.WebPage.Translations,"page.email")}</span>
                        <div className="input-container">
                          <input  ref={(r) => {this.formEmail = r}} defaultValue={eml} type="text" className="input"/>
                          <span className="ico">
                          <i className="fa fa-envelope-open"></i>
                        </span>
                        </div>
                      </div>


                    <input onClick={(e) => {this.handleSubmit(e)}} type="button" className="btn btn--blue" value={wActs.getTranslation(this.props.WebPage.Translations,"page.submit")}/>
                    </form>
                  </React.Fragment>
                }


                {showSuccess &&
                  <div className="centered-content">
                    <i className="fa fa-check-circle" style={{color: "green", fontSize: "185px"}}/><br/>
                    <div style={{marginTop: "30px", fontSize: "55px"}}>{wActs.getTranslation(this.props.WebPage.Translations,"response.messagesent")}</div>
                  </div>
                }


              </div>


              <aside className="aside">
                <div className="aside__item">
                  <div className="aside__item__top flex flex--center">
                    <div className="ico">
                      <i className="fa fa-star"></i>
                    </div>

                    <div className="title">
                      <div className="h2">{wActs.getTranslation(this.props.WebPage.Translations,"page.smuglist.sexworkers")}</div>
                    </div>
                  </div>

                  <p className="text">
                    {wActs.getTranslation(this.props.WebPage.Translations,"page.smuglist.sexworkers.text1")}
                  </p>
                </div>

              </aside>
            </div>

          </div>
        </div>


      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    MainContent: state.Website.Page.Content.Main,
    WebPage: state.Website
  };
}

export default connect(mapStateToProps)(SignUp);
